import type { ReactNode } from 'react';

interface AuthLayoutProps {
    children: ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
    return (
        <div className="flex min-h-dvh flex-col bg-white">
            <div className="mx-6 my-auto flex h-[90vh] overflow-hidden rounded-xl bg-[#f5f5f5] sm:mx-10 lg:ml-20 lg:mr-0 lg:rounded-r-none xl:ml-28">
                {/* Left — Image */}
                <div className="hidden w-[35%] shrink-0 lg:block">
                    <img
                        src="/assets/login-image.png"
                        alt="Person reviewing legal documents"
                        className="h-full w-full object-cover"
                    />
                </div>

                {/* Right — Form */}
                <div className="flex w-full flex-col justify-center px-6 py-16 sm:px-12 lg:w-[65%] lg:px-24 xl:px-32">
                    <div className="max-w-md">
                        <h1 className="text-[28px] font-bold leading-tight text-secondary sm:text-[34px]">
                            MultiDoor Management Dashboard
                        </h1>

                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}
